import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConfig } from '~/Store/Bootstrap/slice';
import { RootState } from '~/Store/reducers';

interface BootstrapSystemProps {
  children: React.ReactNode;
}

export const BootstrapSystem: React.FC<BootstrapSystemProps> = ({ children }) => {
  const dispatch = useDispatch();
  const isSuccess = useSelector((state: RootState) => state.bootstrap.isSuccess);
  const [isFinishedFetching, setIsFinishedFetching] = useState(true);

  // Load config khi component mount
  useEffect(() => {
    dispatch(fetchConfig());
  }, [dispatch]);

  // Chờ config load xong rồi mới render children
  useEffect(() => {
    if (isSuccess === true) {
      setIsFinishedFetching(false);
    }
  }, [isSuccess]);

  // Chỉ render children khi config đã load xong
  return <>{!isFinishedFetching ? children : null}</>;
};

